var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDemoIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5238_73368",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 19,
    width: 32,
    height: 34
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.458 49.8779C23.736 49.8779 23.118 49.6209 22.604 49.1069C22.09 48.5929 21.833 47.9889 21.833 47.2949V24.5029C21.833 23.8083 22.076 23.2043 22.562 22.6909C23.0487 22.1769 23.5557 21.9199 24.083 21.9199H32.125C32.2917 21.1139 32.7013 20.4403 33.354 19.8989C34.0067 19.3569 34.7637 19.0859 35.625 19.0859C36.4863 19.0859 37.2433 19.3569 37.896 19.8989C38.5487 20.4403 38.9723 21.1139 39.167 21.9199H47.208C47.9027 21.9199 48.507 22.1769 49.021 22.6909C49.535 23.2043 49.792 23.8083 49.792 24.5029V33.8359H47.708V24.5029C47.708 24.3643 47.6593 24.2463 47.562 24.1489C47.4653 24.0516 47.3473 24.0029 47.208 24.0029H43V28.5859H28.625V24.0029H24.458C24.2913 24.0029 24.1593 24.0516 24.062 24.1489C23.9653 24.2463 23.917 24.3643 23.917 24.5029V47.2949C23.917 47.4336 23.9653 47.5516 24.062 47.6489C24.1593 47.7463 24.2913 47.7949 24.458 47.7949H33.833V49.8779H24.458ZM51.542 53.0029L46.917 48.4199C46.389 48.8086 45.8057 49.1003 45.167 49.2949C44.5277 49.4889 43.861 49.5859 43.167 49.5859C41.417 49.5859 39.917 48.9609 38.667 47.7109C37.417 46.4609 36.792 44.9473 36.792 43.1699C36.792 41.3919 37.417 39.8849 38.667 38.6489C39.917 37.4129 41.417 36.7949 43.167 36.7949C44.9443 36.7949 46.458 37.4199 47.708 38.6699C48.958 39.9199 49.583 41.4199 49.583 43.1699C49.583 43.8366 49.4927 44.5033 49.312 45.1699C49.132 45.8366 48.8337 46.4199 48.417 46.9199L53 51.5449L51.542 53.0029ZM43.167 47.5029C44.361 47.5029 45.3817 47.0863 46.229 46.2529C47.0763 45.4196 47.5 44.3919 47.5 43.1699C47.5 41.9753 47.0833 40.9613 46.25 40.1279C45.4167 39.2946 44.389 38.8779 43.167 38.8779C41.9723 38.8779 40.9583 39.2946 40.125 40.1279C39.2917 40.9613 38.875 41.9753 38.875 43.1699C38.875 44.3639 39.2917 45.3846 40.125 46.2319C40.9583 47.0793 41.9723 47.5029 43.167 47.5029ZM36 24.1279C36.4167 24.1279 36.7707 23.9823 37.062 23.6909C37.354 23.3989 37.5 23.0446 37.5 22.6279C37.5 22.1833 37.354 21.8223 37.062 21.5449C36.7707 21.2669 36.4167 21.1279 36 21.1279C35.5833 21.1279 35.2293 21.2669 34.938 21.5449C34.646 21.8223 34.5 22.1833 34.5 22.6279C34.5 23.0446 34.646 23.3989 34.938 23.6909C35.2293 23.9823 35.5833 24.1279 36 24.1279Z",
    fill: "#1C1B1F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5238_73368)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 36,
    width: 17,
    height: 18,
    fill: "#A9CF3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 36L21 51H35L36 36H52V18H20V36Z",
    fill: "#587E85"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemoIcon3);
export default __webpack_public_path__ + "static/media/demo-icon3.6b8821e13404d53ab3ae9268bd918141.svg";
export { ForwardRef as ReactComponent };